import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/manufacturing/Template'

const Manufacturing: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 メーカー 製造業 建設業'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/manufacturing/'}
        title="メーカー/製造/建設 | 事例 | i3DESIGN アイスリーデザイン"
        description="メーカー/製造/建設のケーススタディを紹介します｜i3DESIGNはビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Manufacturing
